import React, { useState } from 'react';
import { Card, Button, Alert, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { paymentService } from '../services/paymentService';

const HostedCheckoutForm = ({ registrationData, onPaymentSuccess, onCancel }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handlePayment = async () => {
    setIsLoading(true);
    
    try {
      // Create hosted checkout session
      const checkoutData = {
        amount: registrationData.fee,
        currency: 'INR',
        registrationId: registrationData.id,
        customerInfo: {
          name: registrationData.name,
          email: registrationData.email,
          phone: registrationData.phone || '',
          firstName: registrationData.name?.split(' ')[0] || '',
          lastName: registrationData.name?.split(' ').slice(1).join(' ') || '',
          countryCode: 'IN'
        }
      };

      const response = await paymentService.createHostedCheckout(checkoutData);
      
      if (response.success && response.data.redirectUrl && response.data.hostedCheckoutId) {
        // Store registration data in sessionStorage for when user returns
        sessionStorage.setItem('pendingRegistration', JSON.stringify({
          registrationId: registrationData.id,
          hostedCheckoutId: response.data.hostedCheckoutId,
          merchantReference: response.data.merchantReference
        }));

        // Redirect to Worldline hosted payment page
        window.location.href = response.data.redirectUrl;
      } else if (response.success && response.data.sessionId) {
        // This is a mock payment session response - show success message
        toast.success('Mock payment session created - proceeding with test payment');
        onPaymentSuccess({
          success: true,
          paymentId: response.data.sessionId,
          status: 'MOCK_PAYMENT',
          message: 'Test payment completed successfully'
        });
      } else {
        toast.error('Failed to create payment session');
      }
    } catch (error) {
      console.error('Hosted checkout error:', error);
      toast.error(error.message || 'Failed to initialize payment');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Card className="shadow">
      <Card.Header className="bg-primary text-white">
        <h4 className="mb-0">Complete Payment</h4>
      </Card.Header>
      <Card.Body>
        <Alert variant="info" className="mb-4">
          <div className="d-flex justify-content-between">
            <div>
              <strong>Registration Fee: ₹{registrationData.fee}</strong>
              <br />
              <small>Registration ID: {registrationData.id}</small>
            </div>
            <div className="text-end">
              <small>Participant: {registrationData.name}</small>
            </div>
          </div>
        </Alert>

        <Alert variant="success" className="mb-4">
          <h6>Secure Payment with Worldline</h6>
          <p className="mb-0">
            You will be redirected to Worldline's secure payment page to complete your transaction.
            Your payment information is encrypted and secure.
          </p>
        </Alert>

        <div className="mb-4">
          <h6>Payment Methods Accepted:</h6>
          <ul className="list-unstyled">
            <li>✓ Credit Cards (Visa, Mastercard, American Express)</li>
            <li>✓ Debit Cards</li>
            <li>✓ Net Banking</li>
            <li>✓ UPI</li>
            <li>✓ Digital Wallets</li>
          </ul>
        </div>

        <div className="d-flex justify-content-between">
          <Button
            variant="secondary"
            onClick={onCancel}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            variant="success"
            onClick={handlePayment}
            disabled={isLoading}
            size="lg"
          >
            {isLoading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Redirecting...
              </>
            ) : (
              `Pay ₹${registrationData.fee} Securely`
            )}
          </Button>
        </div>

        <Alert variant="warning" className="mt-4">
          <small>
            <strong>Note:</strong> After completing payment on Worldline's secure page, 
            you will be redirected back to confirm your registration.
          </small>
        </Alert>
      </Card.Body>
    </Card>
  );
};

export default HostedCheckoutForm;
